import React from "react";
import { Box } from "@chakra-ui/react";
import { getCdnImageSrc } from "goi_common";

export interface IntroStep {
  id: string;
  /** 타이틀 위 파란색 강조 라벨 (없으면 미표시) */
  eyebrow?: string;
  title: string;
  description: React.ReactNode;
  imageSrc: string;
  imageAlt: string;
  extraContent?: React.ReactNode;
}

export const PRODUCT_INTRO_STEPS: IntroStep[] = [
  {
    id: "priceLock",
    title: "월 100원으로 예약하는 상조\n부담없이 시작하세요",
    description: (
      <>
        계약금 3만원을 월 100원씩 나눠 내는 상품이에요.
        <p className="body_1_normal_sb">
          지금 가격에서 오르지 않게 미리 계약하고
        </p>
        계약금을 뺀 상조 비용은 장례식 이후에 내면 돼요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/priceLock-flow.png"),
    imageAlt: "월 100원으로 예약하는 상조",
  },
  {
    id: "comparison",
    title: "작년보다 10만원 오른 상조\n나중에 가입하면 더 올라요",
    description: (
      <>
        장례 비용도 매년 오르기 때문이죠.
        <br />
        지금 가격으로 미리 계약하면
        <p className="body_1_normal_sb">10년 후 200만원을 아낄 수 있어요.</p>
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/comparison-chart.png"),
    imageAlt: "나중에 가입하면 더 올라요",
  },
  {
    id: "package",
    title: "언제든 해지해도 괜찮아요\n위약금 없이 100% 환급",
    description: (
      <>
        <p className="body_1_normal_sb">
          상품을 해지하게 되어도 낸 돈은 전부 돌려드려요.
        </p>
        부담될 것 같아서 망설이고 있다면
        <br />
        일단 시작해도 괜찮아요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/package-refund.png"),
    imageAlt: "위약금 없이 100% 환급",
  },
  {
    id: "payment",
    title: "월 100원\n너무 적다고요?",
    description: (
      <>
        <p className="body_1_normal_sb">
          커피 두 잔 값으로 미리 다 준비할 수 있어요.
        </p>
        적금처럼 조금씩 모아두고
        <br />
        장례 걱정 한 번에 끝낼 수 있어요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/payment-compare-2.png"),
    imageAlt: "월 100원 너무 적다고요?",
  },
  {
    id: "memorial",
    title: "월 9,900원 상품만의\n전용 혜택을 확인해 보세요",
    description: (
      <>
        <span className="body_1_normal_sb">최대 120만원 상당</span>의 장례 비용
        지원과 <br />
        여행, 건강검진 등 일상속에서 사용할 수 있는
        <br />
        <span className="body_1_normal_sb">서비스 할인 혜택</span>을 가입 즉시
        이용할 수 있어요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/9900-benefit-2.png"),
    imageAlt: "적립형 상품 가입자에겐 최대 120만원 혜택",
  },
];

// Exp294 B안 Steps
export const PRODUCT_INTRO_EXP294_B_STEPS: IntroStep[] = [
  {
    id: "priceRise",
    title: "매년 오르는 물가에 따라\n장례 비용도 매년 올라요",
    description: (
      <>
        올 해 기준 장례 비용은 1,800만 원
        <br />
        <p className="body_1_normal_sb">10년 사이 300만 원이 올랐어요.</p>
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/price-rise.png"),
    imageAlt: "매년 오르는 장례 비용 그래프",
  },
  {
    id: "saving",
    title: "월 100원이면\n상조 비용은 오르지 않아요",
    description: (
      <>
        100원 상조에 가입하면 고이의 상조 서비스가
        <br />
        <p className="body_1_normal_sb">
          가입 시점의 가격으로 미리 계약되기 때문이죠.
        </p>
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/saving.png"),
    imageAlt: "월 100원 상조 금액 절약",
  },
  {
    id: "earlyBird",
    title: "빨리 가입할 수록\n큰 금액을 아낄 수 있어요",
    description: (
      <>
        만약 지금 가입하면
        <br />
        <p className="body_1_normal_sb">
          10년 후엔 200만원을 아끼는 효과가 있어요.
        </p>
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/early-bird.png"),
    imageAlt: "빨리 가입할수록 아끼는 금액 비교",
  },
  {
    id: "howItWorks",
    title: "100원만 내면\n장례 준비가 끝나는 건가요?",
    description: (
      <>
        월 100원은 상조 비용을 고정시키기에 필요한
        <br />
        계약금으로, 나머지 비용은 장례 이후에 내면 돼요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/priceLock-flow.png"),
    imageAlt: "계약 성립 후 장례 진행 흐름",
  },
  {
    id: "estimate",
    title: "10원 단위까지 나오는\n꼼꼼한 사전 견적",
    description: (
      <>
        고이는 모든 품목과 가격을 미리 안내 드리고
        <br />
        <p className="body_1_normal_sb">그 외 추가 비용이 발생하지 않아요.</p>
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/estimate.png"),
    imageAlt: "10원 단위 꼼꼼한 사전 견적",
  },
  {
    id: "refund",
    title: "언제든 해지해도 괜찮아요\n위약금 없이 100% 환급",
    description: (
      <>
        납입금도 100원에, 해지 위약금도 없으니
        <br />
        <p className="body_1_normal_sb">가입해둬도 손해 볼 일이 없어요.</p>
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/package-refund.png"),
    imageAlt: "위약금 없이 100% 환급",
  },
  {
    id: "upgrade",
    title: "월 100원\n너무 적다고요?",
    description: (
      <>
        월 9,900원으로 준비하는 방법도 있어요.
        <br />
        <p className="body_1_normal_sb">
          적금처럼 모아서 장례 걱정을 한 번에 끝내보세요.
        </p>
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/payment-compare.png"),
    imageAlt: "월 9,900원 적립형 상품 비교",
  },
];

export const TRUST_INTRO_STEPS: IntroStep[] = [
  {
    id: "how",
    title: "100원 상조,\n어떻게 가능한가요?",
    description: (
      <>
        연예인 광고도, 모집인 수당도 없어요.
        <br />
        그래서 가격을 이만큼 낮출 수 있었어요.
        <br />
        <Box as="span" display="block" className="body_1_normal_sb">
          월 100원은 신뢰의 시작이에요.
        </Box>
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/trust-step-1.png"),
    imageAlt: "100원이 어떻게 가능한가요?",
  },
  {
    id: "what",
    title: "100원만 내면\n장례 준비가 끝나는 건가요?",
    description: (
      <>
        월 100원은 계약금 3만원을 나눠 내는 거예요.
        <br />
        <Box as="span" display="block" className="body_1_normal_sb">
          지금 가격 그대로 미리 예약해두고,
        </Box>
        나머지 비용은 장례 이후에 내면 돼요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/priceLock-flow.png"),
    imageAlt: "100원만 내면 장례 준비가 끝나는 건가요?",
  },
  {
    id: "trust",
    title: "고이, 믿을 수 있는\n회사인가요?",
    description: (
      <>
        이미 18만 명이 믿고 맡겨두었고,
        <br />
        <Box as="span" className="body_1_normal_sb">
          실제 후기만 2,000개, 평점 4.9점이에요.
        </Box>
        <br />
        가입하신 돈은 국민은행에 안전하게 보관돼요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/trust-step-3.png"),
    imageAlt: "고이, 믿을 수 있는 회사인가요?",
  },
  {
    id: "review",
    title: "아직 망설여지신다면?",
    description: (
      <>
        같은 고민을 했던 고객님들의
        <br />
        실제 후기를 확인해 보세요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/trust-step-4.png"),
    imageAlt: "아직 망설여지신다면?",
  },
  {
    id: "cancel",
    title: "언제든 해지해도 괜찮아요\n위약금 없이 100% 환급",
    description: (
      <>
        <Box as="span" display="block" className="body_1_normal_sb">
          상품을 해지하게 되어도 낸 돈은 전부 돌려드려요.
        </Box>
        부담될 것 같아서 망설이고 있다면
        <br />
        일단 시작해도 괜찮아요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/package-refund.png"),
    imageAlt: "위약금 없이 100% 환급",
  },
  {
    id: "payment",
    title: "월 100원\n너무 적다고요?",
    description: (
      <>
        <p className="body_1_normal_sb">
          커피 두 잔 값으로 미리 다 준비할 수 있어요.
        </p>
        적금처럼 조금씩 모아두고
        <br />
        장례 걱정 한 번에 끝낼 수 있어요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/payment-compare-2.png"),
    imageAlt: "월 100원 너무 적다고요?",
  },
  {
    id: "memorial",
    title: "월 9,900원 상품만의\n전용 혜택을 확인해 보세요",
    description: (
      <>
        <span className="body_1_normal_sb">최대 120만원 상당</span>의 장례 비용
        지원과 <br />
        여행, 건강검진 등 일상속에서 사용할 수 있는
        <br />
        <span className="body_1_normal_sb">서비스 할인 혜택</span>을 가입 즉시
        이용할 수 있어요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/product-intro/9900-benefit-2.png"),
    imageAlt: "적립형 상품 가입자에겐 최대 120만원 혜택",
  },
];

/** 계약상품 인트로 공통 마지막 2스텝(리뷰, 환급) — 10dc/20dc 퍼널 전부 동일해서 공유 */
const CONTRACT_INTRO_SHARED_TAIL_STEPS: IntroStep[] = [
  {
    id: "reviews",
    title: "멤버십 가입\n아직 망설여진다면?",
    description: (
      <>
        같은 고민을 했던 고객님들의
        <br />
        실제 후기를 확인해 보세요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/contract-intro/10dc-ob-4.png"),
    imageAlt: "멤버십 가입 아직 망설여진다면?",
  },
  {
    id: "refund",
    eyebrow: "고이 멤버십 핵심 혜택",
    title: "언제든 해지해도 괜찮아요\n위약금 없이 100% 환급",
    description: (
      <>
        상품을 해지해도 낸 돈은 전부 돌려드려요.
        <br />
        가입 비용만 잃는건 아닐까 걱정하실 필요 없어요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/contract-intro/10dc-ob-5.png"),
    imageAlt: "언제든 해지해도 괜찮아요 위약금 없이 100% 환급",
  },
];

/** 계약상품(선불결제) 가입 퍼널 인트로 — 1p10dc/10p10dc, Figma node 17900:30928 등 */
export const CONTRACT_PRODUCT_INTRO_STEPS: IntroStep[] = [
  {
    id: "priorityDispatch",
    eyebrow: "고이 멤버십 핵심 혜택",
    title: "고이 선정 최우수 장례지도사\n우선 출동 보장",
    description: (
      <>
        멤버십 회원은 고이에서 고객 후기가 가장 좋고
        <br />
        경력, 실력이 보증된 최우수 장례지도사가 배정돼요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/contract-intro/10dc-ob-1.png"),
    imageAlt: "고이 선정 최우수 장례지도사 우선 출동 보장",
  },
  {
    id: "nightShift",
    eyebrow: "고이 멤버십 핵심 혜택",
    title: "주말, 심야, 새벽 언제든\n24시간 최우선 조치",
    description: (
      <>
        주말이나 새벽 등 장례 요청이 많은 시간에도
        <br />
        멤버십 회원은 최우선적으로 조치를 도와드립니다.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/contract-intro/10dc-ob-2.png"),
    imageAlt: "주말, 심야, 새벽 언제든 24시간 최우선 조치",
  },
  {
    id: "crematoriumReservation",
    eyebrow: "고이 멤버십 핵심 혜택",
    title: "화장장 빈자리 확인부터\n예약까지 신속하게",
    description: (
      <>
        날이 갈 수록 어려워지는 화장장 예약, 걱정 마세요.
        <br />
        멤버십 회원은 최우선 예약을 약속드립니다.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/contract-intro/10dc-ob-3.png"),
    imageAlt: "화장장 빈자리 확인부터 예약까지 신속하게",
  },
  ...CONTRACT_INTRO_SHARED_TAIL_STEPS,
];

/** 1만원 선납 20만원 할인(기초생활수급자, BNF) 가입 퍼널 인트로 — Figma node 17953:33743 등 */
export const CONTRACT_PRODUCT_INTRO_STEPS_BNF: IntroStep[] = [
  {
    id: "bnfDiscount",
    eyebrow: "고이 멤버십 핵심 혜택",
    title: "경제적 취약계층을 위해\n상조 패키지 20만원 할인",
    description: (
      <>
        멤버십 회원은 고이에서 고객 후기가 가장 좋고
        <br />
        경력, 실력이 보증된 최우수 장례지도사가 배정돼요.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/contract-intro/20dc-ob-1.png"),
    imageAlt: "경제적 취약계층을 위해 상조 패키지 20만원 할인",
  },
  {
    id: "bnfBenefits",
    eyebrow: "고이 멤버십 핵심 혜택",
    title: "기초생활수급자 혜택도\n놓치지 않도록",
    description: (
      <>
        주말이나 새벽 등 장례 요청이 많은 시간에도
        <br />
        멤버십 회원은 최우선적으로 조치를 도와드립니다.
      </>
    ),
    imageSrc: getCdnImageSrc("direct/contract-intro/20dc-ob-2.png"),
    imageAlt: "기초생활수급자 혜택도 놓치지 않도록",
  },
  ...CONTRACT_INTRO_SHARED_TAIL_STEPS,
];
